import { ReactNode } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import { HelmetProvider } from 'react-helmet-async';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Layout;
